'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endpoints = {
  audience: {
    brand: {
      many: '/{parent}/brand',
      params: {
        parent: 'audienceId'
      }
    },
    one: '/{record}',
    params: {
      record: 'audienceId'
    },
    shares: {
      one: '/{record}/shares',
      params: {
        record: 'audienceId'
      }
    }
  },
  entity_filter: {
    many: '/entity_filter',
    queryParams: ['audience_type', 'backfilled']
  },
  lookalike: {
    body: {
      brand_id: 'brand_id',
      credential_id: 'credential_id',
      lookalike: 'page'
    },
    many: '/lookalikes'
  },
  owners: {
    body: {
      audience_ids: 'audience_ids',
      audience_type: 'audience_type'
    },
    many: '/owners'
  },
  page: {
    body: {
      brand_id: 'brand_id',
      credential_id: 'credential_id',
      page: 'page'
    },
    many: '/pages'
  }
};

var defaultOptions = {
  prefix: '/audiences'
};

var AudiencesApi = function (_PlatformApi) {
  (0, _inherits3.default)(AudiencesApi, _PlatformApi);

  function AudiencesApi(options) {
    (0, _classCallCheck3.default)(this, AudiencesApi);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AudiencesApi.__proto__ || (0, _getPrototypeOf2.default)(AudiencesApi)).call(this, (0, _assign2.default)({}, defaultOptions, options)));

    _this._endpoints = endpoints;
    return _this;
  }

  return AudiencesApi;
}(_PlatformApi3.default);

exports.default = AudiencesApi;
//# sourceMappingURL=AudiencesApi.js.map